export enum EResult {
  Success,
  Failure
}
